import {getCookies} from '../common/network/apiUtils';

function wrapWithObject(data, objectPathString = 'data') {
  const object = {};
  const pathArr = objectPathString.split('.');
  let current = object;

  for (let i = 0; i < pathArr.length - 1; i++) {
    const key = pathArr[i];
    current[key] = {};
    current = current[key];
  }

  const lastKey = pathArr[pathArr.length - 1];
  current[lastKey] = data;

  return object;
}

function joinWithObject(object, glue, separator) {
  return Object.keys(object).
    map((key) => [key, object[key]].join(glue)).
    join(separator);
}

function jsonParse(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return false;
  }
}

function mergeObjects(obj1, obj2) {
  return Object.assign({}, obj1, obj2);
}

function isEmpty(value) {
  if (value == null) {
    return true;
  }

  if (typeof value === 'string' || Array.isArray(value)) {
    return value.length === 0;
  }

  if (typeof value === 'object') {
    return Object.keys(value).length === 0;
  }

  return false;
}

function deepEqual(x, y) {
  if (x && y && typeof x === 'object' && typeof y === 'object') {
    const xKeys = Object.keys(x);
    const yKeys = Object.keys(y);

    if (xKeys.length !== yKeys.length) {
      return false;
    }

    return xKeys.every((key) => deepEqual(x[key], y[key]));
  }

  return x === y;
}

function camelCase(str) {
  const words = str.split(/[\W_]+/);
  const capitalizedWords = words.map((word, index) => {
    if (index === 0) {
      return word.toLowerCase();
    } else {
      return word.charAt(0).
        toUpperCase() + word.slice(1).
        toLowerCase();
    }
  });
  return capitalizedWords.join('');
}

function upperFirst(str) {
  return str.charAt(0).
    toUpperCase() + str.slice(1);
}

function pickBy(object) {
  const obj = {};
  for (const key in object) {
    if (object[key]) {
      obj[key] = object[key];
    }
  }
  return obj;
}

const snakeCase = (str) => {
  return str.replace(/\s+/g, '_').
    replace(/[^a-zA-Z0-9_]/g, '').
    replace(/([a-z])([A-Z])/g, '$1_$2').
    toLowerCase();
};

const filterCookiesByPrefix = ({cookies, prefixes}) => {
  return Object.keys(cookies)?.
    filter(key => prefixes?.some(prefix => key?.startsWith(prefix)))?.
    reduce((obj, key) => {
      obj[key] = cookies[key];
      return obj;
    }, {})
}

const getCookiesByPrefix = ({rawCookies = '', prefixes = []}) => {
  if (!rawCookies) {
    return {};
  }

  const cookies = getCookies(rawCookies);

  if (prefixes?.length === 0) {
    return cookies;
  }

  return filterCookiesByPrefix({cookies, prefixes})
}

export {
  wrapWithObject,
  joinWithObject,
  jsonParse,
  mergeObjects,
  isEmpty,
  deepEqual,
  camelCase,
  upperFirst,
  pickBy,
  snakeCase,
  getCookiesByPrefix
};
